import { ChakraProvider, ChakraProviderProps } from '@chakra-ui/react';
import { theme } from '../theme';

export function AppThemeProvider(props: ChakraProviderProps) {
  return <ChakraProvider theme={theme} {...props} />;
}
